import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeValue } from '../../../redux/actions/chickenDashAction';
import { MultipleSelectFilter } from '../../../components/Filters';

const DashboardToolbarProducts = ({ materials }) => {
  const dispatch = useDispatch();
  const chickenTypes = useSelector(state => state.chickenDashboard.chickenTypes);
  const [products, setProducts] = useState([...chickenTypes]);
  
  const onChange = useCallback(newMaterials => {
    setProducts(newMaterials);
  }, []);
  
  const onClickOutside = useCallback(() => {
    dispatch(changeValue('chickenTypes', products.sort((a, b) => a.localeCompare(b))));
  }, [dispatch, products]);
  
  useEffect(() => {
    setProducts([...chickenTypes]);
  }, [chickenTypes]);
  
  return (
    <MultipleSelectFilter
      title="Products"
      name="chickenTypes"
      options={materials}
      values={products}
      onChange={onChange}
      onClickOutside={onClickOutside}
    />
  );
};

export default memo(DashboardToolbarProducts);